import type { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

import { cn } from '@/lib/utils';

export type WarningBannerTone = 'amber' | 'orange';

const TONE_CLASS: Record<WarningBannerTone, string> = {
  amber:
    'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-950/30 dark:text-amber-300',
  orange:
    'border-orange-300 bg-orange-50 text-orange-800 dark:border-orange-700 dark:bg-orange-950/30 dark:text-orange-300',
};

export interface WarningBannerProps {
  tone: WarningBannerTone;
  className?: string;
  children: ReactNode;
}

export function WarningBanner({ tone, className, children }: WarningBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-md border p-3 text-sm',
        TONE_CLASS[tone],
        className
      )}
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
